<template>
  <div>
    <v-card>
      <v-toolbar card color="white">
        <v-text-field
          flat
          solo
          hide-details
          prepend-icon="search"
          placeholder="Tìm trên danh sách xe"
          v-model="table.searchText"
          v-on:keyup.enter="search()"
        ></v-text-field>
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="exportToFile">
            <v-icon>save_alt</v-icon>
          </v-btn>
          <span>Tải về danh sách xe</span>
        </v-tooltip>
        <v-menu offset-y origin="center center" :nudge-bottom="10" v-if="isFilter">
          <v-btn icon slot="activator">
            <v-icon>filter_list</v-icon>
          </v-btn>
          <v-card>
            <v-card-title>Bộ lọc</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-radio-group v-model="filter" column>
                <v-radio label="Tất cả" value="All"></v-radio>
                <v-radio label="Xe đang chạy" value="Running"></v-radio>
                <v-radio label="Xe đang dừng" value="Stopped"></v-radio>
                <v-radio label="Xe quá tốc độ" value="OverSpeed"></v-radio>
                <v-radio label="Xe đang tắt máy" value="AccOff"></v-radio>
                <v-radio
                  label="Xe bị mất kết nối"
                  value="Disconnection"
                ></v-radio>
                <v-radio label="Xe bị khóa" value="Lock"></v-radio>
                <v-radio label="Xe hết hạn" value="Expire"></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-menu>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <v-data-table
          item-key="id"
          :headers="table.headers"
          :items="datasourceFiltered"
          :rows-per-page-items="[10, 20, 50, 100]"
          :loading="isLoading"
          :pagination.sync="paginationSync"
          @update:pagination="changePage"
          :total-items="totalItems"
        >
          <template slot="items" slot-scope="props">
            <tr @contextmenu.prevent="openContextMenu($event, props.item)">
              <td>{{ props.item.dealerName }}</td>
              <td>
                <v-btn
                  flat
                  round
                  small
                  color="primary"
                  class="link-button account-name"
                  :to="getAccountDetailLink(props.item.accountId)"
                  >{{ props.item.accountName }}</v-btn
                >
              </td>
              <td class="no-wrap">{{ props.item.username }}</td>
              <td class="no-wrap">
                {{ props.item.plate }}
                <v-tooltip top v-if="props.item.plate">
                  <v-icon
                    slot="activator"
                    small
                    class="copy-icon"
                    :color="copiedKey === 'plate-' + props.item.id ? 'success' : ''"
                    @click.stop="copyToClipboard(props.item.plate, 'plate-' + props.item.id)"
                    >{{ copiedKey === 'plate-' + props.item.id ? 'check' : 'content_copy' }}</v-icon
                  >
                  <span>Sao chép biển số</span>
                </v-tooltip>
              </td>
              <td>
                <img
                  slot="activator"
                  height="30"
                  class="vehicle-icon"
                  :src="getVehicleIcon(props.item)"
                />
              </td>
              <td style="min-width: 200px">{{ getVehicleStatus(props.item) }}</td>
              <td class="no-wrap">
                {{ props.item.imei }}
                <v-tooltip top v-if="props.item.imei">
                  <v-icon
                    slot="activator"
                    small
                    class="copy-icon"
                    :color="copiedKey === 'imei-' + props.item.id ? 'success' : ''"
                    @click.stop="copyToClipboard(props.item.imei, 'imei-' + props.item.id)"
                    >{{ copiedKey === 'imei-' + props.item.id ? 'check' : 'content_copy' }}</v-icon
                  >
                  <span>Sao chép IMEI</span>
                </v-tooltip>
              </td>
              <td class="no-wrap">
                {{ props.item.devicetype }}
                <v-tooltip top v-if="props.item.devicetype">
                  <v-icon
                    slot="activator"
                    small
                    class="copy-icon"
                    :color="copiedKey === 'devicetype-' + props.item.id ? 'success' : ''"
                    @click.stop="copyToClipboard(props.item.imei + ' - ' + props.item.devicetype, 'devicetype-' + props.item.id)"
                    >{{ copiedKey === 'devicetype-' + props.item.id ? 'check' : 'content_copy' }}</v-icon
                  >
                  <span>Sao chép IMEI - Loại thiết bị</span>
                </v-tooltip>
              </td>
              <td>{{ props.item.simPhone }}</td>
              <td>{{ props.item.iccId }}</td>
              <td class="no-wrap">
                {{ getDateFormatted(props.item.simIdDate) }}
              </td>
              <td class="no-wrap">
                {{ getDateFormatted(props.item.activatedDate) }}
              </td>
              <td class="no-wrap">{{ props.item.remainExpiryDay }}</td>
              <td class="no-wrap">
                {{ getDateFormatted(props.item.expiryDay) }}
              </td>
              <td class="no-wrap">{{ props.item.odooRemainExpiryDay }}</td>
              <td class="no-wrap">
                {{ getDateFormatted(props.item.odooExpiryDay) }}
              </td>
              <td>
                <v-icon class="menu-item-icon" v-show="props.item.isLocked"
                  >lock</v-icon
                >
              </td>
              <td class="no-wrap">
                {{ getDateFormatted(props.item.createdDate) }}
              </td>
              <td class="no-wrap">
                {{ getDateFormatted(props.item.lockedTime) }}
              </td>
              <td class="no-wrap">
                {{ getDateFormatted(props.item.renewDate) }}
              </td>
              <td class="no-wrap">{{ props.item.assignee }}</td>
              <td>
                <div class="text-xs-center">
                  <v-menu offset-y>
                    <v-btn icon flat slot="activator" color="primary">
                      <v-icon>expand_more</v-icon>
                    </v-btn>
                    <v-list>
                      <v-list-tile
                        v-for="(item, index) in menu"
                        :key="index"
                        @click="item.click(props.item)"
                      >
                        <v-list-tile-title>
                          <v-icon class="menu-item-icon">{{
                            item.icon
                          }}</v-icon>
                          <span>{{ item.title }}</span>
                        </v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- Context Menu -->
    <vue-context
      ref="contextMenu"
      v-if="loggedUser && (loggedUser.isProvider || loggedUser.isDistributor)"
    >
      <v-list>
        <v-list-tile
          v-for="(item, index) in menu"
          :key="index"
          @click="item.click()"
        >
          <v-list-tile-title>
            <v-icon class="menu-item-icon">{{ item.icon }}</v-icon>
            <span>{{ item.title }}</span>
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </vue-context>
    <!-- End Context Menu -->

    <!-- Switch Device Dialog -->
    <v-dialog
      v-model="switchDeviceDialog"
      persistent
      max-width="360"
      v-if="selectedItem"
    >
      <switch-device
        :vehicle="selectedItem"
        @show="switchDeviceDialog = $event"
      ></switch-device>
    </v-dialog>
    <!-- Switch Device Dialog -->

     <!-- Switch Device Upgrade Dialog -->
    <!-- <v-dialog
      v-model="switchDeviceUpgradeDialog"
      persistent
      max-width="360"
      v-if="selectedItem"
    >
      <switch-device-upgrade
        :vehicle="selectedItem"
        @show="switchDeviceUpgradeDialog = $event"
      ></switch-device-upgrade>
    </v-dialog> -->
    <!-- Switch Device Dialog -->

    <!-- Delete Vehicle Dialog -->
    <v-dialog
      v-model="deleteVehicleDialog"
      persistent
      max-width="360"
      v-if="selectedItem"
    >
      <delete-vehicle
        :vehicle="selectedItem"
        @show="deleteVehicleDialog = $event"
      ></delete-vehicle>
    </v-dialog>
    <!-- Delete Vehicle Dialog -->

    <!-- Lock Vehicle Dialog -->
    <v-dialog
      v-model="lockVehicleDialog"
      persistent
      max-width="360"
      v-if="selectedItem"
    >
      <lock-vehicle
        :vehicle="selectedItem"
        @show="lockVehicleDialog = $event"
      ></lock-vehicle>
    </v-dialog>
    <!-- Lock Vehicle Dialog -->

    <!-- Dialog tra cứu thông tin sim -->
    <dialog-search-sim ref="dialogSearchSim" />
    <!-- Dialog tra cứu thông tin sim -->
  </div>
</template>

<script>
import XLSX from 'xlsx';
import validate from '@/utils/validate';
import * as MapUtil from '@/utils/maputil';
import * as FormatUtil from '@/utils/datetime';
import { VueContext } from 'vue-context';
import { mapGetters, mapActions } from 'vuex';
import DeleteVehicle from './Delete';
import LockVehicle from './Lock';
import SwitchDevice from './SwitchDevice';
// import SwitchDeviceUpgrade from './SwitchDeviceUpgrade';
import DialogSearchSim from './DialogSearchSim';

export default {
  components: {
    VueContext,
    DeleteVehicle,
    SwitchDevice,
    // SwitchDeviceUpgrade,
    LockVehicle,
    DialogSearchSim
  },

  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    datasource: {
      type: Array,
      default: []
    },
    totalItems: {
      type: Number,
      default: 0
    },
    isFilter: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      validate: validate,
      table: {
        searchText: '',
        headers: [
          {
            text: 'Nhà phân phối / Đại lý',
            value: 'dealerName'
          },
          {
            text: 'Khách hàng',
            value: 'accountName'
          },
          {
            text: 'username',
            value: 'username'
          },
          {
            text: 'Biển số',
            value: 'plate'
          },
          {
            text: 'Biểu tượng',
            value: 'status'
          },
          {
            text: 'Trạng thái',
            value: 'stateModel.time'
          },
          {
            text: 'IMEI',
            value: 'imei'
          },
          {
            text: 'Type',
            value: 'devicetype'
          },
          {
            text: 'SĐT Sim',
            value: 'simPhone'
          },
          {
            text: 'IccId',
            value: 'iccId'
          },
          {
            text: 'Ngày cập nhật sim',
            value: 'simIdDate'
          },
          {
            text: 'Ngày kích hoạt',
            value: 'activatedDate'
          },
          {
            text: 'Ngày còn lại',
            value: 'remainExpiryDay'
          },
          {
            text: 'Ngày hết hạn',
            value: 'expiryDay'
          },
          {
            text: 'Ngày còn lại Odoo',
            value: 'odooRemainExpiryDay'
          },
          {
            text: 'Ngày hết hạn Odoo',
            value: 'odooExpiryDay'
          },
          {
            text: 'Bị khóa',
            value: 'isLocked'
          },
          {
            text: 'Ngày tạo',
            value: 'createdDate'
          },
          {
            text: 'Ngày khoá',
            value: 'lockedTime',
          },
          {
            text: 'Ngày làm mới',
            value: 'renewDate',
          },
          {
            text: 'Người làm mới',
            value: 'assignee'
          },
          {
            text: '',
            value: '#'
          }
        ]
      },
      menu: [
        {
          title: 'Gửi lệnh',
          icon: 'tap_and_play',
          click: (item) => {
            this.sendCommand(item);
          }
        },
        {
          title: 'Đổi thiết bị bảo hành',
          icon: 'warehouse',
          click: item => {
            if (item) this.selectedItem = item;
            this.switchDeviceDialog = true;
          }
        },
        // {
        //   title: 'Đổi thiết bị nâng cấp',
        //   icon: 'upgrade',
        //   click: item => {
        //     if (item) this.selectedItem = item;
        //     this.switchDeviceUpgradeDialog = true;
        //   }
        // },
        {
          title: 'Khóa',
          icon: 'lock',
          click: item => {
            if (item) this.selectedItem = item;
            this.lockVehicleDialog = true;
          }
        },
        // {
        //   title: 'Tra cứu sim',
        //   icon: 'sim_card',
        //   click: item => {
        //     if (item) this.selectedItem = item;
        //     this.openDialogSearchSim();
        //   }
        // },
        {
          title: 'Xóa',
          icon: 'delete',
          click: item => {
            if (item) this.selectedItem = item;
            this.deleteVehicleDialog = true;
          }
        }
      ],
      filter: 'All',
      datasourceFiltered: [],
      copiedKey: null,
      copiedTimer: null,
      selectedItem: null,
      deleteVehicleDialog: false,
      lockVehicleDialog: false,
      switchDeviceDialog: false,
      switchDeviceUpgradeDialog: false,
      paginationSync: { // Pagination cho table
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      },
      params: { // Params dùng để lấy danh sách
        keySearch: '',
        pageIndex: 1,
        pageSize: 10
      },
    };
  },

  computed: {
    ...mapGetters(['loggedUser'])
  },

  watch: {
    filter (newFilter, oldFilter) {
      // Xóa giá trị filter cũ đã được set cho pagination
      delete this.params[oldFilter];

      // Set giá trị filter mới cho pagination
      this.params[newFilter] = true;
      this.params.pageIndex = 1;

      // Set page = 1 cho table khi được filter
      this.paginationSync.page = 1;

      this.$emit('changePage', { params: this.params, typeFilter: this.filter });
    },
    datasource () {
      this.datasourceFiltered = this.datasource;
      console.log('datasource -> this.datasourceFiltered', this.datasourceFiltered);
    },

    totalItems () {
      this.countExportFile = Math.ceil(this.totalItems / 10000);
    }
  },

  methods: {
    getAccountDetailLink: accountId => `/account/detail?accountId=${accountId}`,

    getDateFormatted: value => {
      return value ? new Date(value).toISOString().slice(0, 10) : '';
    },

    getVehicleIcon: vehicle => {
      return MapUtil.getVehicleIcon(vehicle);
    },

    getVehicleStatus: vehicle => {
      let result = MapUtil.getVehicleStatus(vehicle);
      vehicle.status = result;
      if (vehicle.stateModel && vehicle.stateModel.time) {
        result += ` (${FormatUtil.formatSecondToGPSTime(
          vehicle.stateModel.time
        )})`;
      }
      return result;
    },

    exportToFile () {
      this.$emit('exportFile');
    },

    copyToClipboard (text, key) {
      if (!text) return;

      const markCopied = () => {
        this.copiedKey = key;
        clearTimeout(this.copiedTimer);
        this.copiedTimer = setTimeout(() => {
          if (this.copiedKey === key) this.copiedKey = null;
        }, 1500);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(markCopied).catch(() => {});
        return;
      }

      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        document.execCommand('copy');
        markCopied();
      } catch (err) {
        // ignore
      }
      document.body.removeChild(textarea);
    },

    openContextMenu (event, item) {
      this.selectedItem = item;
      if (this.loggedUser.isProvider || this.loggedUser.isDistributor) {
        this.$refs.contextMenu.open(event);
      }
    },

    openDialogSearchSim () {
      this.$refs.dialogSearchSim.open(this.selectedItem.simPhone);
    },

    sendCommand (item) {
      if (item) this.selectedItem = item;
      let deviceId = this.selectedItem.deviceId;
      let deviceType = this.selectedItem.deviceType || '';
      let imei = this.selectedItem.imei;
      let simPhone = this.selectedItem.simPhone;
      let plate = this.selectedItem.plate;
      window.open(
        `#/monitor?deviceId=${deviceId}&imei=${imei}&plate=${plate}&deviceType=${deviceType}&simPhone=${simPhone}`
      );
    },

    search () {

      let searchText = this.table.searchText.trim();
      this.paginationSync.page = 1;
      this.params.keySearch = searchText;
      this.params.pageIndex = 1;
      this.$emit('changePage', { params: this.params, typeFilter: this.filter });
    },

    changePage (pagination) {
      this.params.pageIndex = pagination.page;
      this.params.pageSize = pagination.rowsPerPage;

      this.$emit('changePage', { params: this.params, typeFilter: this.filter });
    }
  }
};
</script>

<style scoped>
.v-card__text {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.link-button {
  min-width: 0px !important;
  margin-left: 15px !important;
}
.dealer-name {
  min-width: 0px !important;
  margin-left: -8px !important;
}
.account-name {
  margin-top: 10px;
}
.vehicle-icon {
  margin-top: 5px;
}
.copy-icon {
  font-size: 16px;
  cursor: pointer;
  vertical-align: middle;
  margin-left: 4px;
  opacity: 0.6;
}
.copy-icon:hover {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/vehicle/components/list.vue